import { render } from "./NavigateBack.vue?vue&type=template&id=edb3565e"
import script from "./NavigateBack.vue?vue&type=script&lang=js"
export * from "./NavigateBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__